import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Sparkles, Loader2, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) {
      setError("Le due password non coincidono.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      toast.success("Password aggiornata");
      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F8FAFC] px-4">
      <div className="w-full max-w-md">
        <Link to="/" className="mb-8 flex items-center justify-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-slate-900 text-white">
            <Sparkles className="h-5 w-5" />
          </span>
          <span className="font-display text-lg font-bold">A Tutto Bando</span>
        </Link>

        <div className="rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
          {!token ? (
            <p className="text-center text-sm text-slate-500" data-testid="reset-invalid">
              Link non valido. Richiedi un nuovo reset dalla pagina di accesso.
            </p>
          ) : done ? (
            <div className="flex flex-col items-center gap-3 text-center" data-testid="reset-success">
              <CheckCircle2 className="h-10 w-10 text-emerald-500" />
              <h1 className="font-display text-xl font-bold">Password aggiornata</h1>
              <p className="text-sm text-slate-500">Ti stiamo reindirizzando all'accesso...</p>
            </div>
          ) : (
            <>
              <h1 className="font-display text-2xl font-bold tracking-tight">Nuova password</h1>
              <p className="mt-2 text-sm text-slate-500">Scegli una nuova password per il tuo account.</p>
              <form onSubmit={submit} className="mt-6 space-y-4">
                <div className="space-y-1.5">
                  <Label htmlFor="np">Nuova password</Label>
                  <Input id="np" type="password" data-testid="reset-password-input"
                    placeholder="Almeno 6 caratteri" value={password}
                    onChange={(e) => setPassword(e.target.value)} required />
                </div>
                <div className="space-y-1.5">
                  <Label htmlFor="cp">Conferma password</Label>
                  <Input id="cp" type="password" data-testid="reset-confirm-input"
                    placeholder="Ripeti la password" value={confirm}
                    onChange={(e) => setConfirm(e.target.value)} required />
                </div>
                {error && (
                  <p className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-600" data-testid="reset-error">{error}</p>
                )}
                <Button type="submit" className="h-11 w-full gap-2 text-base" disabled={loading} data-testid="reset-submit-button">
                  {loading && <Loader2 className="h-4 w-4 animate-spin" />}
                  Aggiorna password
                </Button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
